import script from "./FamilyCharacteristicsSection.vue?vue&type=script&setup=true&lang=js"
export * from "./FamilyCharacteristicsSection.vue?vue&type=script&setup=true&lang=js"

import "./FamilyCharacteristicsSection.vue?vue&type=style&index=0&id=8856812e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8856812e"]])

export default __exports__